// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2Rp50","small":"_264Xu _2Rp50","full":"_2WoVZ _2Rp50"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Helpers/Code/Code.scss
 ** module id = 445
 ** module chunks = 0
 **/